import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCB17fs9nZhIQDCqT78F5v_nD8OO664vFo",
  authDomain: "charproof-nz.firebaseapp.com",
  projectId: "charproof-nz",
  storageBucket: "charproof-nz.firebasestorage.app",
  messagingSenderId: "727274739047",
  appId: "1:727274739047:web:223a4db41fd2d7c8150bc2"
};

const app = initializeApp(firebaseConfig);

export { app };